'use strict';

angular.module('directives.focus', [])

.directive('focus', [function() {
    return {
        link: function (scope, element, attrs) {
            scope.$watch(attrs.focus, function (value) {
                if (value === true) {
                    element[0].focus();
                    scope[attrs.focus] = false;
                }
            });
        }
    };
}]);